













import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class RequestError extends Vue {
  @Prop({ default: "_sentence.something_went_wrong" })
  public title!: string;

  @Prop({ default: "_sentence.request_error_msg" })
  public message!: string;

  @Prop({ default: "_action.reload" })
  public buttonLabel!: string;

  @Prop({ default: false })
  public isLoading!: boolean;
}
